import { render, staticRenderFns } from "./VisitProductSelectionDemo.vue?vue&type=template&id=125e7036"
import script from "./VisitProductSelectionDemo.vue?vue&type=script&lang=js"
export * from "./VisitProductSelectionDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports